import { WorkerStatuses } from '../../helpers/workerStatuses';

export const isSSNorTFNMandatory = (statuses, status) => {
  return statuses.splice(statuses.indexOf(WorkerStatuses.START_BACKGROUND_CHECK)).includes(status);
};
